import { useEffect, useState } from 'react'
import { config } from '../config'

const useDatabase = (content: 'articles' | 'news'): [any[], boolean] => {
    const [data, setData] = useState([])
    const [isLoaded, setLoaded] = useState(false)

    const URL = content === 'articles' ? `${config.API_URL}` : `${config.NEWS_URL}`

    useEffect(() => {
        if (content) {
            const fetchData = async () => {
                const site_content = await fetch(URL).then((response) => response.json())
                const contentData = site_content.entries.filter((entry: any) => entry.publish === true)
                console.log(contentData)
                setData(contentData.sort((a: any, b: any) => a.order - b.order))
                setLoaded(true)
            }
            fetchData()
        }
    }, [URL, content])

    return [data, isLoaded]
}

export default useDatabase
